/*@flow*/

export default ({ url, fileName }: { url: string, fileName?: string }) => {
  const downloadLink = document.createElement('a');
  downloadLink.href = url;
  if (fileName) downloadLink.download = fileName;
  document.body && document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body && document.body.removeChild(downloadLink);
};
